import { Locale } from '@royalaholddelhaize/ah-locale';
import be from './nl-be.json';
import nl from './nl-nl.json';

export const resources = {
    [Locale.nl_NL]: nl,
    [Locale.nl_BE]: be,
};
